'use client';

import { useState, useEffect } from 'react';
import CookieConsent from './CookieConsent';
import { getCookiePreferences, CookiePreferences } from '@/lib/cookies';

interface CookieSettingsProps {
  onPreferencesChange?: (preferences: CookiePreferences) => void;
}

export default function CookieSettings({ onPreferencesChange }: CookieSettingsProps) {
  const [showModal, setShowModal] = useState(false);
  const [hasConsent, setHasConsent] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    
    // Check if user has already given consent
    const existingPreferences = getCookiePreferences();
    setHasConsent(!!existingPreferences);
  }, []);


  const handlePreferencesChange = (preferences: CookiePreferences) => {
    setHasConsent(true);
    setShowModal(false);
    onPreferencesChange?.(preferences);
  };

  // Don't render on server-side to avoid hydration issues
  if (!mounted) return null;

  return (
    <>
      {/* Floating Cookie Settings Button - only show if user has given consent */}
      {hasConsent && (<>
      </>
        // <div style={{
        //   position: 'fixed',
        //   bottom: '16px',
        //   left: '16px',
        //   zIndex: 40
        // }}>
        //   <button
        //     onClick={handleOpenSettings}
        //     style={{
        //       backgroundColor: '#1f2937',
        //       color: '#ffffff',
        //       padding: '12px',
        //       borderRadius: '50%',
        //       border: 'none',
        //       cursor: 'pointer',
        //       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        //       transition: 'all 0.3s ease',
        //       display: 'flex',
        //       alignItems: 'center',
        //       justifyContent: 'center'
        //     }}
        //     onMouseOver={(e) => {
        //       e.currentTarget.style.backgroundColor = '#111827';
        //       e.currentTarget.style.transform = 'scale(1.05)';
        //     }}
        //     onMouseOut={(e) => {
        //       e.currentTarget.style.backgroundColor = '#1f2937';
        //       e.currentTarget.style.transform = 'scale(1)';
        //     }}
        //     title="Cookie Settings"
        //     aria-label="Open Cookie Settings"
        //   >
        //     <svg 
        //       style={{ 
        //         width: '20px', 
        //         height: '20px',
        //         transition: 'transform 0.2s'
        //       }} 
        //       fill="currentColor" 
        //       viewBox="0 0 20 20"
        //     >
        //       <path 
        //         fillRule="evenodd" 
        //         d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" 
        //         clipRule="evenodd" 
        //       />
        //     </svg>
        //   </button>
        // </div>
      )}

      {/* Cookie Consent Modal */}
      {showModal && (
        <CookieConsent onPreferencesChange={handlePreferencesChange} />
      )}
    </>
  );
}
